import { t } from "@/i18n-js/instance";
import { DimensionInput } from "@circle-react-shared/BuilderUI/Editor/fields/DimensionInput";
import { EditorCollapsable } from "../../../../Editor/EditorCollapsable";

export const Sizing = () => (
  <EditorCollapsable title={t("builder_ui.prop_type.styles.size")} defaultOpen>
    <div className="px-6 pb-5">
      <div className="grid grid-cols-2 gap-x-4">
        <DimensionInput
          name="styles.sizing.width"
          label={t("builder_ui.prop_type.styles.width")}
        />
        <DimensionInput
          name="styles.sizing.height"
          label={t("builder_ui.prop_type.styles.height")}
        />
        <DimensionInput
          name="styles.sizing.minWidth"
          label={t("builder_ui.prop_type.styles.min_width")}
        />
        <DimensionInput
          name="styles.sizing.minHeight"
          label={t("builder_ui.prop_type.styles.min_height")}
        />
        <DimensionInput
          name="styles.sizing.maxWidth"
          label={t("builder_ui.prop_type.styles.max_width")}
        />
        <DimensionInput
          name="styles.sizing.maxHeight"
          label={t("builder_ui.prop_type.styles.max_height")}
        />
      </div>
    </div>
  </EditorCollapsable>
);
